import apiDefault from '@/services/api/defaultApi';

export default {
    namespaced: true,
    state: {
        sourceCategories: [],
        reportersCategories: [],
        helpCriteria: [],
        volunteerRefusalReason: [],
        turnOffReasons: [],
        availableWioStructs: [],
        wioStructInfo: {},
        noVolunteersTurnOffReasons: [],
        familyVolunteers: null,
        provincesForFamiliesToAccept: []
    },
    getters: {
        getSourceCategories (state) {
            return state.sourceCategories;
        },
        getOnlyVisibleSourceCategories (state) {
            return state.sourceCategories?.filter((category) => category?.visible);
        },
        getReportersCategories (state) {
            return state.reportersCategories;
        },
        getHelpCriteria (state) {
            return state.helpCriteria;
        },
        getVolunteerRefusalReason (state) {
            return state.volunteerRefusalReason;
        },
        getTurnOffReasons: (state) => state.turnOffReasons,
        getAvailableWioStructs: (state) => state.availableWioStructs,
        getWioStructInfo: (state) => state.wioStructInfo,
        getNoVolunteersTurnOffReasons: (state) => state.noVolunteersTurnOffReasons,
        getFamilyVolunteers: (state) => state.familyVolunteers,
        getProvincesForFamiliesToAccept: (state) => state.provincesForFamiliesToAccept
    },
    mutations: {
        setSourceCategories (state, payload) {
            state.sourceCategories = payload;
        },
        setReportersCategories (state, payload) {
            state.reportersCategories = payload;
        },
        setHelpCriteria (state, payload) {
            state.helpCriteria = payload;
        },
        setVolunteerRefusalReason (state, payload) {
            state.volunteerRefusalReason = payload;
        },
        setTurnOffReasons (state, payload) {
            state.turnOffReasons = payload;
        },
        setAvailableWioStructs (state, payload) {
            state.availableWioStructs = payload;
        },
        setWiosStructInfo (state, payload) {
            state.wioStructInfo = payload;
        },
        setNoVolunteersTurnOffReasons (state, payload) {
            state.noVolunteersTurnOffReasons = payload;
        },
        setFamilyVolunteers (state, payload) {
            state.familyVolunteers = payload;
        },
        setProvincesForFamiliesToAccept (state, payload) {
            state.provincesForFamiliesToAccept = payload;
        }
    },
    actions: {
        async getSourceCategories (context) {
            if (context.getters.getSourceCategories.length <= 0) {
                const { data } = await apiDefault.getSourceCategories();
                context.commit('setSourceCategories', data.data);
            }
        },
        async getReportersCategories (context) {
            if (context.getters.getReportersCategories.length <= 0) {
                const { data } = await apiDefault.getReportersCategories();
                context.commit('setReportersCategories', data.data);
            }
        },
        async getHelpCriteria (context) {
            if (context.getters.getHelpCriteria.length <= 0) {
                const { data } = await apiDefault.getHelpCriteria();
                context.commit('setHelpCriteria', data.data);
            }
        },
        async getVolunteerRefusalReason (context) {
            if (context.getters.getVolunteerRefusalReason.length <= 0) {
                const { data } = await apiDefault.getVolunteerRefusalReason();
                context.commit('setVolunteerRefusalReason', data.data);
            }
        },
        async getTurnOffReasons (context) {
            if (context.getters.getTurnOffReasons.length <= 0) {
                const { data } = await apiDefault.getTurnOffReasons();
                context.commit('setTurnOffReasons', data.data);
            }
        },
        async getAvailableWioStructs (context) {
            if (context.getters.getAvailableWioStructs.length <= 0) {
                const { data } = await apiDefault.getAvailableWioStructs();
                context.commit('setAvailableWioStructs', data.data);
            }
        },
        async getWioStructInfo (context, id) {
            const params = new URLSearchParams();
            if (context.rootGetters['warehouses/getWarehouseWasEdited']) {
                params.append('force_refresh', '1');
            }
            const { data } = await apiDefault.getWioStructInfo(id, params);
            context.commit('setWiosStructInfo', data.data);
        },
        async getNoVolunteersTurnOffReasons (context) {
            if (context.getters.getNoVolunteersTurnOffReasons.length <= 0) {
                const { data } = await apiDefault.getNoVolunteersTurnOffReasons();
                context.commit('setNoVolunteersTurnOffReasons', data.data);
            }
        },
        getFamilyVolunteers (context, id) {
            return apiDefault.getFamilyVolunteers(id).then((data) => {
                context.commit('setFamilyVolunteers', data.data.data);
            });
        },
        async getProvincesForFamiliesToAccept (context) {
            const { data } = await apiDefault.getProvincesForFamiliesToAccept();
            context.commit('setProvincesForFamiliesToAccept', data.data);
        }
    }
};
